/**
 * NGキーワードが含まれている部分を置換する（部分一致も含む）
 * @param text 置換対象のテキスト
 * @param ngKeywords NGキーワードの配列
 * @returns 置換後のテキスト
 */
export const replaceNGKeywords = (
  text: string,
  ngKeywords: string[]
): string => {
  let result = text;

  // NGキーワードを長い順にソート
  const sortedKeywords = ngKeywords.sort((a, b) => b.length - a.length);

  for (const keyword of sortedKeywords) {
    const regex = new RegExp(escapeRegExp(keyword), 'gi');
    result = result.replace(regex, '●'.repeat(keyword.length));
  }

  return result;
};

const escapeRegExp = (str: string) => {
  return str.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&');
};

export const filterNgTags = (tags: string[], ngKeywords: string[]): string[] =>
  tags.filter((tag) => !ngKeywords.includes(tag));
